import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactGA from 'react-ga'
const Contact = () => {
      useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top of the page
    }, []);
    const [status, setStatus] = useState("Submit");
    const navigate = useNavigate();
    const [info, setInfo] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    });
    useEffect(() => {
        ReactGA.pageview(window.location.pathname);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;

        // Perform validations
        if (name === 'name') {
            // Allow only alphabets and spaces
            newValue = value.replace(/[^a-zA-Z\s]/g, '');
        } else if (name === 'phone') {
            // Allow only digits and limit to 10 characters
            newValue = value.replace(/\D/g, '').slice(0, 10);
        }

        setInfo({
            ...info,
            [name]: newValue,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        ReactGA.event({
            category: "contact us",
            action: "Submit button click",
            value: 1,
        });

        try {
            let response = await fetch(`/api/contact`, {
                method: "POST",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8",
                },
                body: JSON.stringify(info),
            });
            setStatus("Submitted");
            setInfo({ name: "", email: "", phone: "", subject: "", message: "" });
            let result = await response.json();
            console.log(result);

            // Navigate to ThankYou page
            navigate("/thankyou");
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };


    return (
        <div>
            <section class="boldSection bottomSemiSpaced btPageHeadline gutter topSemiSpaced btTextLeft wBackground cover btParallax btDarkSkin btBackgroundOverlay btSolidDarkBackground "
                style={{
                    backgroundColor: "#142340",
                    // Use the low resolution image here
                    backgroundPosition: "center", // Center the background image
                    backgroundSize: "auto", // Make the background image cover the entire container
                    dataParallax: "0.8",
                    dataParallaxOffset: "0",
                    marginLeft:"-40px"
                }}>
                <div class="port">
                    <header class="header btClear large">
                        <div class="btSuperTitle">
                            <span>
                                <div class="btBreadCrumbs">
                                    <nav className="brmb">
                                        <ul>
                                            <li><a href="/">Home</a></li>
                                            <li><a href="#">Contact us</a></li>
                                        </ul>
                                    </nav>
                                </div>
                            </span>
                        </div>
                        <div class="dash">
                            <h2><span class="headline brmb2">  Contact</span></h2>
                        </div>
                        <div class="btSubTitle brmb3">"Need assistance? Our team is ready to help! Reach out to us via phone, email, or the contact form below."</div>
                    </header>
                </div>
            </section>



            <section style={{ paddingLeft: "50px", display: "flex" }}>
                <div className="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein inherit btLightSkin animated" data-width="6" >
                    <div className="rowItemContent" style={{ backgroundColor: 'rgba(255,255,255,255)' }}>
                        <div className="boldRow" style={{ maxWidth: '580px', float: 'right' }}>
                            <div className="boldRowInner">
                                <div className="rowItem rowInnerItem col-sm-12 btTextLeft" style={{marginLeft:"-50px"}}>
                                    <div className="rowItemContent">
                                        <div className="btClear btSeparator topSemiSpaced noBorder"><hr /></div>
                                        <header className="header btClear medium btDash bottomDash regular">
                                            <div className="btSuperTitle"><span></span></div>
                                            <div className="dash"><h3><span className="headline">Contact us</span></h3></div>
                                            <div className="btSubTitle">"Have questions or inquiries? Feel free to reach out to us using the contact information below. We're here to assist you!".</div>
                                        </header>
                                        <div className="btClear btSeparator topSmallSpaced noBorder"><hr /></div>
                                        <div className="btText">
                                            <div className="wpcf7 js" id="wpcf7-f4-p1675-o1" lang="en-US" dir="ltr">
                                                <div className="screen-reader-response"><p role="status" aria-live="polite" aria-atomic="true"></p><ul></ul></div>


                                                <form action="/blue-laboratory/about-us/contact/#wpcf7-f4-p1675-o1" onSubmit={handleSubmit} method="post" className="wpcf7-form init" aria-label="Contact form" noValidate="novalidate" data-status="init">
                                                    <div style={{ display: 'none' }}>
                                                        <input type="hidden" name="_wpcf7" value="4" />
                                                        <input type="hidden" name="_wpcf7_version" value="5.9.3" />
                                                        <input type="hidden" name="_wpcf7_locale" value="en_US" />
                                                        <input type="hidden" name="_wpcf7_unit_tag" value="wpcf7-f4-p1675-o1" />
                                                        <input type="hidden" name="_wpcf7_container_post" value="1675" />
                                                        <input type="hidden" name="_wpcf7_posted_data_hash" value="" />
                                                        <input type="hidden" name="_wpcf7_recaptcha_response" value="" />
                                                    </div>
                                                    <p><label>Your Name (required)<br />
                                                        <span className="wpcf7-form-control-wrap" data-name="your-name">
                                                            <input size="40" id="name" name="name" className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required" aria-required="true" aria-invalid="false" type="text" value={info.name} onChange={handleChange} style={{ width: "400px" }} />
                                                        </span>
                                                    </label></p>
                                                    <p><label>Your Email (required)<br />
                                                        <span className="wpcf7-form-control-wrap" data-name="your-email">
                                                            <input size="40" id="email" name="email" className="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email" aria-required="true" aria-invalid="false" type="email" value={info.email} onChange={handleChange} style={{ width: "400px" }} />
                                                        </span>
                                                    </label></p>
                                                    <p><label>Your Phone Number (required)<br />
                                                        <span className="wpcf7-form-control-wrap" data-name="your-email">
                                                            <input size="40" id="phone" name="phone" className="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email" aria-required="true" aria-invalid="false" type="email" value={info.phone} onChange={handleChange} style={{ width: "400px" }} />
                                                        </span>
                                                    </label></p>
                                                    <p><label>Subject<br />
                                                        <span className="wpcf7-form-control-wrap" data-name="your-subject">
                                                            <input size="40" className="wpcf7-form-control wpcf7-text" aria-invalid="false" id=" phone" name="subject" type="text" value={info.subject} onChange={handleChange} style={{ width: "400px" }} />
                                                        </span>
                                                    </label></p>
                                                    <p><label>Your Message<br />
                                                        <span className="wpcf7-form-control-wrap" data-name="your-message">
                                                            <textarea cols="40" rows="10" id="subject" name="message" className="wpcf7-form-control wpcf7-textarea" aria-invalid="false" value={info.message} onChange={handleChange} style={{ width: "400px", height: "100px" }}></textarea>
                                                        </span>
                                                    </label></p>
                                                    <p><input className="wpcf7-form-control wpcf7-submit has-spinner" type="submit" value="Send" /><span className="wpcf7-spinner"></span></p>
                                                    <div className="wpcf7-response-output" aria-hidden="true"></div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="btClear btSeparator topSemiSpaced noBorder"><hr /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rowItem col-md-6 col-sm-12 btTextLeft animate animate-fadein inherit animated" data-width="6">
                    <div class="rowItemContent">
                        <div class="bpgPhoto out-left">
                            <div className="elementor-custom-embed" style={{ paddingTop: "60px", height: "800px" }}>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15551.005205702344!2d77.701766!3d12.9877523!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae119db64c2f21%3A0xfadda48ebb35fe09!2sAutomet!5e0!3m2!1sen!2sin!4v1713333882038!5m2!1sen!2sin" className="map" style={{ border: "0", width: "500px", height: "660px" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>




    );
}

export default Contact